angular.module('bb.util').directive('autoFocusOn', autoFocusOn);

autoFocusOn.$inject = ['$timeout'];

function autoFocusOn($timeout) {
  return {
    restrict: 'A',
    link(scope, element) {
      $timeout(() => {
        element[0].focus();
      }, 0);
    },
  };
}

export {};
